import type { KambiHistoryCoupon } from '@mobi/api-types/kambi'
import type { KambiSportBetDetails } from '@core/Areas/ShareBet/LoadBet/types'
import type { BetLoopKambiShareCoupon } from '@core/Areas/BetLoop/types'
import { getKambiCouponBetType } from '@core/Areas/Kambi/Components/BetHistory/helpers/getKambiCouponBetType'

/** Used for Bet Loop & External Share. Expects only single bet */
export const createKambiCouponLoadBetDetails = (
  coupon: KambiHistoryCoupon | BetLoopKambiShareCoupon
): KambiSportBetDetails[] => {
  if (coupon.bets.length !== 1) return []

  const outcomeIds = coupon.couponRows.flatMap(couponRow => {
    if (!coupon.bets[0].couponRowIndexes.includes(couponRow.index)) return []

    if (couponRow.outcomeGroup) {
      return couponRow.outcomeGroup.groups.map(({ outcomeIds }) => outcomeIds).flat()
    } else {
      return [couponRow.outcomeId]
    }
  })

  const kambiSportBetDetails: KambiSportBetDetails = {
    betSelectionType: getKambiCouponBetType(coupon),
    betOfferIds: [],
    outcomeIds: [],
  }

  return [
    coupon.outcomes.reduce((prev, { betOfferId, outcomeId }) => {
      if (!outcomeIds.includes(outcomeId)) return prev

      kambiSportBetDetails.betOfferIds.push(betOfferId)
      kambiSportBetDetails.outcomeIds.push(outcomeId)

      return prev
    }, kambiSportBetDetails),
  ]
}
